import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { FadeUp } from "@/components/Reveal";

export default function GuideCard({ g, index = 0 }) {
  return (
    <FadeUp delay={(index % 3) * 0.1} className="h-full">
      <Link
        to={`/guides/${g.slug}`}
        data-testid={`guide-card-${g.slug}`}
        className="group flex flex-col h-full bg-white border border-border hover:border-gold hover:-translate-y-1 hover:shadow-lg transition-[transform,border-color,box-shadow] duration-500"
      >
        {g.featured_image && (
          <div className="overflow-hidden max-h-52 relative">
            <img src={g.featured_image} alt={g.title} loading="lazy"
              className="h-52 w-full object-cover saturate-[0.75] transition-transform duration-700 group-hover:scale-105" />
            <div className="absolute inset-0 bg-navy/20 group-hover:bg-navy/10 transition-colors duration-500" />
          </div>
        )}
        <div className="flex flex-col flex-1 p-7">
          <p className="text-xs uppercase tracking-[0.2em] text-gold font-semibold">{g.category}</p>
          <h3 className="mt-3 font-serif text-2xl font-medium text-navy leading-snug">{g.title}</h3>
          <p className="mt-3 text-sm text-navy/60 leading-relaxed flex-1">{g.excerpt}</p>
          <div className="mt-6 flex items-center justify-between">
            <span className="text-xs text-navy/40">{g.read_time}</span>
            <span className="inline-flex items-center gap-2 text-sm font-semibold text-navy group-hover:text-gold transition-colors duration-300">
              Read <ArrowUpRight className="h-4 w-4" />
            </span>
          </div>
        </div>
      </Link>
    </FadeUp>
  );
}
